<div id="calender">
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <div class="card shadow-lg">
                    <h4 class="card-title text-center">2026-27</h4>
                    <div class="card-body">
                        <iframe src="/assets/pdf/Academic%20Calendar%202026-27.pdf" width="100%" height="980" allow="autoplay"></iframe>
                    </div>
                </div>

            </div>
        </div>

       
    </div>
</div>
